import {
  DeclaredRetriever,
  FactsResponse,
  FRONT_DOOR_FACTS_PATH,
} from "@internal/plugin-front-door-common";
import { FrontDoorApis, getFrontDoorJson } from "../frontDoorApi";
import { cached } from "./cache";

/**
 * The declared facts from the front-door backend, shared for five minutes; undefined
 * when it can't be read, so facts show their descriptions instead.
 */
export function loadDeclaredRetrievers(
  apis: FrontDoorApis
): Promise<DeclaredRetriever[] | undefined> {
  return cached("front-door:facts", () =>
    getFrontDoorJson<FactsResponse>(apis, FRONT_DOOR_FACTS_PATH, "Facts")
  ).then(
    (body) => body.retrievers,
    () => undefined
  );
}
